// extracted by mini-css-extract-plugin
export var list = "asideNav-module--list--L9nRO";
export var active = "asideNav-module--active--2OA6a";